import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import * as styles from './Brand.scss';

var Brand = /*#__PURE__*/function (_Component) {
  _inherits(Brand, _Component);

  var _super = _createSuper(Brand);

  function Brand() {
    _classCallCheck(this, Brand);

    return _super.apply(this, arguments);
  }

  _createClass(Brand, [{
    key: "render",
    value: function render() {
      var imgLinkStyle = {
        color: this.props.theme.colors.primaryColor,
        backgroundImage: this.props.image_url ? "url(".concat(this.props.image_url, ")") : null,
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        height: '100%'
      };
      return /*#__PURE__*/React.createElement("div", {
        className: styles.brand
      }, /*#__PURE__*/React.createElement(Link, {
        className: styles.link,
        to: this.props.link,
        alt: this.props.text,
        style: imgLinkStyle
      }));
    }
  }]);

  return Brand;
}(Component);

_defineProperty(Brand, "propTypes", {
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
  image_url: PropTypes.any,
  theme: PropTypes.object.isRequired
});

_defineProperty(Brand, "defaultProps", {
  isPartner: false,
  link: '/'
});

_defineProperty(Brand, "styleguide", {
  title: 'Button',
  sample_code: '<Button text="a button" type="button"/>'
});

export default Brand;